import React from "react"
import { ProductOption } from "app/components/ProductOption"
import { useAppflow } from "app/hooks/useAppFlow"
import Heading from "app/components/Heading"
import { useTranslate } from "hooks/translate"
import { ClientEnum } from "../types"
import { StyledGrid } from "../style"

export const ClientTypeSelector: React.FC = () => {
  const { t } = useTranslate()
  const { navigate } = useAppflow()

  return (
    <div>
      <Heading>{t("system.b2b_or_b2c")}</Heading>
      <StyledGrid>
        <ProductOption
          title="B2B"
          description={t("system.solution_b2b")}
          onClick={() => navigate(ClientEnum.Business)}
        />
        <ProductOption
          title="B2C"
          description={t("system.solution_b2c")}
          onClick={() => navigate(ClientEnum.Private)}
        />
      </StyledGrid>
    </div>
  )
}
